import { CardImg as _CardImg, CardImgProps as _CardImgProps } from "reactstrap";

    export const CardImg = _CardImg;
    export type CardImgProps = _CardImgProps;
    